import { useSelector, useDispatch } from 'react-redux';
import { useFormContext, useFieldArray, Controller } from 'react-hook-form';
import HorizontalFormInput from '../../../../../../../../components/FormHelpers/horizontalFormInput';
import { MdClear } from 'react-icons/md';
import { AutoComplete } from 'antd';
import { actionCreators } from '../../data/Recipients/actions';

const SearchField = ({ 
  field, 
  fieldState,
  className, 
  id, 
  label, 
  index, 
  placeholder, 
  isFetching, 
  helpText, 
  disabled, 
  recipients, 
  findRecipients, 
  autofillSelectedRecipients,
}) => {
  const { isTouched, error } = fieldState;

  return (
    <div className='form-group form-group--horizontal'>
      <div>
        <label htmlFor={id} className="label">{label}</label>
      </div>
      <div>
        <AutoComplete
          options={recipients}
          onSearch={findRecipients}
          onSelect={(e) => {
            const data = JSON.parse(e);
            field.onChange(data.email);
            autofillSelectedRecipients(data, index);
          }}
          notFoundContent={isFetching ? <div>Laddar e-postadresser...</div> : null}
          style={{ width: '100%' }}
          value={field.value}
          onChange={(e) => {
            if (typeof e === 'string' && e.charAt(0) === "{") {
              const data = JSON.parse(e);
              field.onChange(data.email);
            } else {
              field.onChange(e);
            }
            findRecipients('');
          }}
        >
          <input 
            {...field}
            placeholder={placeholder} 
            type="text"
            className={`${className} ${isTouched && error ? 'form-control--has-error' : ''} ${!error && isTouched ? 'form-control--has-success' : ''}`} 
            id={id} 
            disabled={disabled} 
          />
        </AutoComplete>
        {isTouched && error ? (
          <span className='help-text help-text--has-error'>{error.message}</span>
        ) : helpText && <span className="help-text">{helpText}</span>}
      </div>
    </div>
  );
};

const Recipients = () => {
  const dispatch = useDispatch();
  const { control, setValue } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'recipients'
  });

  const recipientsEmails = useSelector(state => 
    state.Admin.scenes.Deliveries.scenes.new.data.recipients.data.map((recipient) => ({ 
      value: JSON.stringify(recipient), 
      label: `Email: ${recipient.email}, Name: ${recipient.firstName} ${recipient.lastName}, Phone: ${recipient.cell}` 
    }))
  );
  const isFetching = useSelector(state => state.Admin.scenes.Deliveries.scenes.new.data.recipients.isFetching);

  const findRecipients = (search) => {
    dispatch(actionCreators.findRecipients(search));
  };

  const autofillSelectedRecipients = (recipient, index) => {
    setValue(`recipients.${index}.email`, recipient.email ?? '', { shouldValidate: true, shouldDirty: true });
    setValue(`recipients.${index}.firstName`, recipient.firstName ?? '', { shouldValidate: true, shouldDirty: true });
    setValue(`recipients.${index}.lastName`, recipient.lastName ?? '', { shouldValidate: true, shouldDirty: true });
    setValue(`recipients.${index}.cell`, recipient.cell ?? '', { shouldValidate: true, shouldDirty: true });
    setValue(`recipients.${index}.companyName`, recipient.companyName ?? '', { shouldValidate: true, shouldDirty: true });
    setValue(`recipients.${index}.organizationNo`, recipient.organizationNo ?? '', { shouldValidate: true, shouldDirty: true });
  };

  const removeSingleRecipient = (index) => {
    remove(index);
  };

  return (
    <>
      {fields.map((field, index) => (
        <div className="card" key={field.id}>
          <div className="card-header">
            <span className="card-header__title">
              Mottagare {index + 1}
            </span>
            <div className="card-header__actions">
              <button
                className="card__action card__action--remove"
                type="button"
                title="Remove recipient"
                onClick={() => {
                  removeSingleRecipient(index);
                  remove(index);
                }}
              >
                <MdClear />
              </button>
            </div>
          </div>
          <div className="card__body form">
            <Controller
              name={`recipients.${index}.email`}
              control={control}
              render={({ field, fieldState }) => (
                <SearchField
                  field={field}
                  fieldState={fieldState}
                  className="form-control"
                  label="E-postadress"
                  findRecipients={findRecipients}
                  autofillSelectedRecipients={autofillSelectedRecipients}
                  isFetching={isFetching}
                  recipients={recipientsEmails}
                  index={index}
                />
              )}
            />
            <HorizontalFormInput 
              name={`recipients.${index}.firstName`}
              control={control}
              className="form-control" 
              label="Förnamn" 
            />
            <HorizontalFormInput 
              name={`recipients.${index}.lastName`}
              control={control}
              className="form-control" 
              label="Efternamn" 
            />
            <HorizontalFormInput 
              name={`recipients.${index}.cell`}
              control={control}
              className="form-control" 
              label="Mobilnummer" 
            />
            <HorizontalFormInput 
              name={`recipients.${index}.companyName`}
              control={control}
              className="form-control" 
              label="Företagsnamn" 
            />
            <HorizontalFormInput 
              name={`recipients.${index}.organizationNo`}
              control={control}
              className="form-control" 
              label="Organisationsnummer" 
            />
          </div>
        </div>
      ))}
      <button type="button" onClick={() => append({})} className="btn btn--block btn--secondary">
        &#43; Lägg till mottagare
      </button>
    </>
  );
};

export default Recipients;